import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { getItemApi } from '../../../apiUtils';
import { Loader } from '../../../components/loader/Loader';
import { Asset } from '../../../types/asset.types';
import { API_URL } from '../../../utils/apiUrl';
import MobileLayout from '../../Tasks/Mobile/components/MobileLayout';
import * as Bar from '../../WorkSheets/Mobile/components/Bar';
import { AssetsMobileEditForm } from './AssetsMobileEditForm';

export interface PageParams {
  assetId: string;
}

export const AssetsMobileEditPage = () => {
  const history = useHistory();
  const { assetId } = useParams<PageParams>();

  const [asset, setAsset] = useState<Asset | null>(null);
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    getAsset();
  }, []);

  const getAsset = async () => {
    setLoading(true);
    await getItemApi<Asset>({
      url: `${API_URL.ASSET_ITEM}`,
      params: {
        id: assetId,
      },
      callAfterSuccess: (result) => {
        setAsset(result);
      },
    });
    setLoading(false);
  };

  if (isLoading || !asset) return <Loader />;

  return (
    <MobileLayout>
      <Bar.SummaryNavBar
        title={asset.name!}
        onBack={() =>
          history.push({
            pathname: '/mobile',
          })
        }
      />
      <AssetsMobileEditForm
        assetId={Number(assetId)}
        defaultFormData={{
          parentAssetId: asset.parentAssetId,
          name: asset.name!,
          description: asset.description,
          typeId: asset.typeId,
          inventoryNumber: asset.inventoryNumber,
          serialNumber: asset.serialNumber,
          model: asset.model,
          producedBySupplierName: asset.producedBySupplierName,
          assetLocationId: asset.assetLocationId,
          building: asset.building,
          room: asset.room,
          statusId: asset.statusId,
        }}
      />
    </MobileLayout>
  );
};
